import React from "react";

const TableContainer = ({ children, className }) => {
    return (
        <div className={`p-6 bg-white rounded shadow-md ${className}`}>
            <div className="overflow-x-auto">{children}</div>
        </div>
    );
};

export default TableContainer;
